export default "__VITE_ASSET__DZkMXDu1__"